import './ProductCard.css';
import oneStar from './assets/images/product-card/1-star.svg';
import halfStar from './assets/images/product-card/half-star.svg';
import width from './assets/images/product-card/width.svg';
import depth from './assets/images/product-card/depth.svg';
import height from './assets/images/product-card/height.svg';

function renderStarImages(ratingText, key) {
  const rating = parseFloat(ratingText); // Extract numeric rating
  const fullStars = Math.floor(rating);  // Whole number of stars
  const hasHalfStar = rating % 1 >= 0.5; // Check for half star

  const starImages = [];

  // Add full star images
  for (let i = 0; i < fullStars; i++) {
    starImages.push(<img key={`${key}-star-${i}`} className="icon" src={oneStar} />);
  }

  // Add half star image if needed
  if (hasHalfStar) {
    starImages.push(<img key={`${key}-halfstar`} className="icon" src={halfStar} />);
  }

  return starImages;
}

function renderEnergy(ratingText, key) {
  if(ratingText == null || ratingText == "") {
  } else {
    return <div className="product-star-rating">
      <span>Energy</span>
      {renderStarImages(ratingText, key)}
    </div>
  }
}

function renderWater(ratingText, key) {
  if(ratingText == null || ratingText == "") {
  } else {
    return <div className="product-star-rating">
      <span>Water</span>
      {renderStarImages(ratingText, key)}
    </div>
  } 
}

function renderMeasurement(image, name, value) {
  if(value == null || value == "") {
  } else {
    return <div className="column horiz-flex-cont">
      <div className="fixed">
        <img className="icon" src={image} />
      </div>
      <div className="body">
        <span className="name">{name}</span>
        <span className="value">{value}</span>
      </div>
    </div>
  }
}

function renderImage(image) {
  if(image.indexOf('http') == 0) {
    return <img src={image} />  
  } else {
    return <img src={`/images/products/${image}`} />
  }
}

function isValidHtmlString(str) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');
    // Check for parser errors (e.g., if the HTML is malformed)
    return doc.body.children.length > 0 || doc.head.children.length > 0;
  } catch (e) {
    return false;
  }
}

const ProductCard = ({ product }) => {
  const { Image, Name, VendorItemNo, People, Description, Warranty, EstAnnualRunningCost, WidthCm, DepthCm, HeightCm, Energy, Water } = product;
  let runningCost;
  try {
    runningCost = parseFloat(EstAnnualRunningCost).toFixed(2);
  } catch(err) {
    runningCost = EstAnnualRunningCost;
    console.error(err);
  }

  let descriptionHtml;
  if(isValidHtmlString(Description)) {
    descriptionHtml = <div className="description" dangerouslySetInnerHTML={{ __html: Description }} ></div>
  } else {
    descriptionHtml = <div className="description">
      <p>{Description}</p>
    </div>
  }

  return (
    <div className="product-card">
      <div className="horiz-flex-cont full-height">
        <div className="product-image fixed">
          <div className="people-badge">
            {People}
           </div>
          <div className="product-image-center">
            {renderImage(Image)}
          </div>
        </div>
        <div className="product-details body">
          <h2>{Name}</h2>
          <h3>{VendorItemNo}</h3>
          <hr/>
          <div className="product-dimensions three-col-flex-container">
            {renderMeasurement(width, "WIDTH", `${WidthCm}cm`)}
            {renderMeasurement(depth, "DEPTH", `${DepthCm}cm`)}
            {renderMeasurement(height, "HEIGHT", `${HeightCm}cm`)}
          </div>
          <hr/>
          <div className="product-specifications">
            <p>{Warranty}</p>
            {renderEnergy(Energy, VendorItemNo)}
            {renderWater(Water, VendorItemNo)}
            <p>Est. annual running cost ${runningCost}</p>
          </div>
          <hr/>
          {descriptionHtml}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;